import { React } from "react";
import { Paper, Typography, Container, List, ListItem } from "@material-ui/core";
import useStyles from "./styles.js";

const Research = () => {
    const classes = useStyles();

    return (
        <Container className={classes.container} fullWidth>
            <Paper className={classes.researchQuestion}>
                <Typography className={classes.title} variant="h4">
                    Research Information
                </Typography>
                <Typography className={classes.information} variant="h6">
                    Data on the Internet is at{" "}
                    <div style={{ display: "inline-block" }}>
                        <a
                            href="https://www.verizon.com/about/news/quantum-computing-encryption-standards"
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: "none", color: "red" }}
                        >
                            risk
                        </a>
                    </div>{" "}
                    due to the computational power of quantum computers. This is an important
                    problem because so much data is either in transit over the Internet or stored in
                    some way such that it can be easily accessed from the Internet, but is currently
                    protected by encryption. Quantum computers can break this encryption, leaving{" "}
                    <div style={{ display: "inline-block" }}>
                        <a
                            href="https://www.technologyreview.com/2019/05/30/65724/how-a-quantum-computer-could-break-2048-bit-rsa-encryption-in-8-hours/"
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: "none", color: "red" }}
                        >
                            no data safe
                        </a>
                    </div>{" "}
                    on the Internet.
                </Typography>
                <Typography className={classes.informationTwo} variant="h6">
                    Recently, NIST released a list of{" "}
                    <div style={{ display: "inline-block" }}>
                        <a
                            href="https://csrc.nist.gov/News/2022/pqc-candidates-to-be-standardized-and-round-4"
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: "none", color: "#3DED97" }}
                        >
                            quantum resistant cryptographic algorithms
                        </a>
                    </div>
                    ; however, it is hard for the general public to understand and implement them.
                    We aim to make this information easier to understand and utilize in order to
                    ease the transition into a world of quantum computing.
                </Typography>
                <Typography className={classes.informationThree}>
                    <Typography className={classes.listTitle} variant="h6">
                        Our goals for the 2022-2023 year are to
                    </Typography>
                    <Typography className={classes.list} variant="body">
                        <ul>
                            <li>
                                Research current cryptographic algorithms which are vulnerable to
                                attacks
                            </li>
                            <li>Learn more about the NIST winners and how they resist attacks</li>
                            <li>Create implementations for those candidates </li>
                        </ul>
                    </Typography>
                </Typography>
            </Paper>
        </Container>
    );
};

export default Research;
